import { TranslateStaticLoader } from 'ng2-translate';
import { Observable } from 'rxjs/Observable';
import { Http } from '@angular/http';

function recursiveIterate(obj) {
  if (typeof obj !== 'object') {
    return obj;
  } else if (Array.isArray(obj)) {
    return obj.join('');
  } else {
    Object.keys(obj).forEach(key => {
      obj[key] = recursiveIterate(obj[key]);
    });
    return obj;
  }
}

export class CustomLoader extends TranslateStaticLoader {
  constructor(http: Http, prefix?: string, suffix?: string) {
    super(http, prefix, suffix);
  }

  getTranslation(lang: string): Observable<any> {
    // return Observable.of({ KEY: 'value' });
    return super.getTranslation(lang).map(res => recursiveIterate(res)).share();
  }
}



// WEBPACK FOOTER //
// ./src/app/misc/translation-loader.ts